export default __webpack_public_path__ + "static/media/jr_slug.d0693049.png";